import Button from '@components/Button';
import AdminConfig from '@config/admin';
import '@css/Admin/index.scss';
import Alert from '@material-ui/lab/Alert';
import { apiClient } from '@services/api';
import { dateLocale, slugfy, translator } from '@utils/helpers';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import {
  Route,
  Switch,
  useHistory,
  // Redirect,
  useParams, useRouteMatch
} from "react-router-dom";
import ReactToPrint from 'react-to-print';
import Header from './partials/Header';
import calendar from '@assets/images/icons/calendar.png';
import clock from '@assets/images/icons/clock.png';
import person from '@assets/images/icons/person.png';

class Content extends React.Component {
  render() {
    const props = this.props;
    const queryParams = new URLSearchParams(window.location.search);
    const tourDate = queryParams.get('tourDate');
    const exitId = queryParams.get('exitId');
    if (!props.voucher || !props.voucher.customerData) return null;
    const idiom = (props.voucher.customerData.language || 'pt').toUpperCase();

    const formatHour = time => {
      if (time) {
        const hourArrar = time.split(":")
        const hour = new Date().setHours(hourArrar[0], hourArrar[1]);
        return format(hour, "HH:mm")
      }
      return null
    }

    const language = {
      pt: 'Português',
      en: 'Inglês',
      es: 'Espanhol'
    };

    const getTimes = (v) => {
      if (v?.vehicle?.time_final) {
        return 'Entre ' + v?.vehicle?.time.substr(0, 5) + ' e ' + v?.vehicle?.time_final.substr(0, 5)
      }
      return v?.vehicle?.time
    }

    const primaryColor = process.env.REACT_APP_PRIMARY_COLOR || '#102F55';
    const accentColor = process.env.REACT_APP_SELLER_COLOR || '#62DEC2';

    const s = {
      wrap: { background: '#fff', maxWidth: '960px', fontFamily: 'Poppins, sans-serif', color: '#1e293b', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
      header: { background: primaryColor, padding: '24px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' },
      logoWrap: { background: '#fff', borderRadius: '8px', padding: '6px 10px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '70px' },
      headerTitle: { color: '#fff', fontSize: '20px', fontWeight: '700', marginBottom: '2px' },
      headerSub: { color: 'rgba(255,255,255,0.75)', fontSize: '12px' },
      headerRight: { color: 'rgba(255,255,255,0.85)', fontSize: '12px', textAlign: 'right', lineHeight: '1.7' },
      passengerBar: { background: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '16px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
      label: { fontSize: '10px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '2px' },
      value: { fontSize: '15px', fontWeight: '600', color: '#1e293b' },
      valueSub: { fontSize: '12px', color: '#64748b', marginTop: '1px' },
      body: { padding: '24px 28px' },
      tourName: { fontSize: '18px', fontWeight: '700', color: primaryColor, marginBottom: '16px', paddingBottom: '12px', borderBottom: `2px solid ${accentColor}` },
      cardsRow: { display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' },
      card: { flex: '1', minWidth: '120px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '14px 16px', textAlign: 'center' },
      cardIcon: { fontSize: '22px', marginBottom: '6px' },
      cardLabel: { fontSize: '10px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' },
      cardValue: { fontSize: '15px', fontWeight: '700', color: '#1e293b' },
      cardValueSm: { fontSize: '13px', fontWeight: '600', color: '#1e293b' },
      infoRow: { display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' },
      infoBox: { flex: '1', minWidth: '200px', background: '#f1f5f9', borderRadius: '8px', padding: '12px 16px' },
      infoBoxAccent: { flex: '1', minWidth: '200px', borderRadius: '8px', padding: '12px 16px', background: `linear-gradient(135deg, ${primaryColor}15, ${accentColor}20)`, border: `1px solid ${accentColor}40` },
      staffRow: { display: 'flex', gap: '12px', marginTop: '16px', flexWrap: 'wrap' },
      staffBox: { flex: '1', minWidth: '140px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '10px' },
      staffIcon: { fontSize: '24px', opacity: '0.6' },
      footer: { background: '#f8fafc', borderTop: '1px solid #e2e8f0', padding: '14px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' },
      footerText: { fontSize: '11px', color: '#94a3b8' },
    };

    return (
      <div id='desktop' style={s.wrap}>
        {/* Header */}
        <div style={s.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {props.voucher.company.logo && (
              <div style={s.logoWrap}>
                <img src={`${process.env.REACT_APP_BASE_IMAGE_URL}/${props.voucher.company.logo}`} style={{ width: '70px', height: 'auto' }} alt="" />
              </div>
            )}
            <div>
              <div style={s.headerTitle}>Voucher de Saída</div>
              <div style={s.headerSub}>{props.voucher.company.name}</div>
            </div>
          </div>
          <div style={s.headerRight}>
            <div>{props.voucher.company.phone}</div>
            <div>{props.voucher.company.address}</div>
          </div>
        </div>

        {/* Passenger bar */}
        <div style={s.passengerBar}>
          <div>
            <div style={s.label}>Passageiro</div>
            <div style={s.value}>{props.voucher.reservationData.customer_name}</div>
            <div style={s.valueSub}>{props.voucher.customerData.email} &bull; {props.voucher.reservationData.customer_telephone}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={s.label}>Reserva</div>
            <div style={s.value}>#{props.voucher.id}</div>
            <div style={s.valueSub}>Ref: {props.voucher.references}</div>
          </div>
        </div>

        {/* Body */}
        <div style={s.body}>
          {props.voucher.status === 'canceled' && (
            <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px' }}>
              ⚠️ Reserva cancelada por {props.voucher.logs?.name} em <Moment format="DD/MM/YYYY" date={props.voucher.logs?.created_at} />
            </div>
          )}

          {props.voucher.reservations.map((v, idx) => {
            if (!(v?.exit_id == exitId && v?.id && v.tour_date.substr(0, 10) == tourDate.substr(0, 10))) return null;
            const tourTitle = v?.type === 'tour' ? v?.travel.name : v?.travel.region_name;
            const transferLabel = v?.type === 'transfer' ? ` (Transfer ${v?.transfer_type})` : '';
            const timeDisplay = v?.times !== null ? getTimes(v) : formatHour(v?.flight_time) || '-';

            return (
              <div key={idx}>
                <div style={s.tourName}>{tourTitle}{transferLabel}</div>

                {/* Key info cards */}
                <div style={s.cardsRow}>
                  <div style={s.card}>
                    <div style={s.cardIcon}>📅</div>
                    <div style={s.cardLabel}>Data</div>
                    <div style={s.cardValue}><Moment format="DD/MM/YYYY" date={v?.tour_date} /></div>
                  </div>
                  <div style={s.card}>
                    <div style={s.cardIcon}>🕐</div>
                    <div style={s.cardLabel}>Horário</div>
                    <div style={s.cardValue}>{timeDisplay}</div>
                  </div>
                  <div style={s.card}>
                    <div style={s.cardIcon}>👥</div>
                    <div style={s.cardLabel}>Passageiros</div>
                    <div style={s.cardValueSm}>{v?.adults_total} adulto{v?.adults_total > 1 ? 's' : ''}{v?.kids_total > 0 ? `, ${v?.kids_total} criança${v?.kids_total > 1 ? 's' : ''}` : ''}</div>
                  </div>
                  {v?.type === 'transfer' && v?.flight_code && (
                    <div style={s.card}>
                      <div style={s.cardIcon}>✈️</div>
                      <div style={s.cardLabel}>Voo</div>
                      <div style={s.cardValue}>{v?.flight_code}</div>
                    </div>
                  )}
                </div>

                {/* Meeting point */}
                {props.voucher.reservationData.address_hotel && (
                  <div style={s.infoRow}>
                    <div style={s.infoBoxAccent}>
                      <div style={{ ...s.label, color: primaryColor }}>📍 Ponto de Encontro</div>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', marginTop: '4px' }}>{props.voucher.reservationData.address_hotel}</div>
                    </div>
                  </div>
                )}

                {/* Staff */}
                {(v?.guide?.name || v?.driver?.name) && (
                  <div style={s.staffRow}>
                    {v?.guide?.name && (
                      <div style={s.staffBox}>
                        <div style={s.staffIcon}>🧭</div>
                        <div>
                          <div style={s.cardLabel}>Guia</div>
                          <div style={{ fontSize: '14px', fontWeight: '600' }}>{v?.guide?.name}</div>
                        </div>
                      </div>
                    )}
                    {v?.driver?.name && (
                      <div style={s.staffBox}>
                        <div style={s.staffIcon}>🚌</div>
                        <div>
                          <div style={s.cardLabel}>Motorista</div>
                          <div style={{ fontSize: '14px', fontWeight: '600' }}>{v?.driver?.name}</div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div style={s.footer}>
          <div style={s.footerText}>{props.voucher.customerData.name} &bull; {props.voucher.customerData.document}</div>
          <div style={s.footerText}>{dateLocale(props.voucher.created_at)}</div>
        </div>
      </div>
    );
  }
}

const VoucherLink = props => {
  let { path } = useRouteMatch();
  const history = useHistory();
  const componentRef = useRef()
  const { sale_id, exit_id, token } = useParams();
  const [voucher, setVoucher] = useState({});
  const [loading, setLoading] = useState(true);
  const [sendingVoucher, setSendingVoucher] = useState(false);
  let url = `/customer/get_sale_voucher/${sale_id}?access_token=${token}`;
  const [success, setSuccess] = useState(false);
  const sendVoucherUrl = `sales/${sale_id}/send_voucher`;

  const getVoucher = url => {
    apiClient.httpInstance.get(url).then(response => {
      if (response.status === 200) {
        setVoucher(response.data);
        setLoading(false);
      }
    }).catch(function (response) {
      setLoading(false);
    });
  }

  const sendVoucher = () => {
    setSendingVoucher(true);
    apiClient.httpInstance.post(sendVoucherUrl).then(response => {
      if (response.status === 200) {
        setSuccess(true);
        setSendingVoucher(false);
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      }
    });
  }

  useEffect(() => {
    getVoucher(url);
  }, [url]);

  let theme = AdminConfig.themes[slugfy(props?.user?.data?.permission)] || AdminConfig.themes.logistica;

  return <Switch>
    <React.Fragment>
      <div className="flex flex-col admin">
        <Header theme={theme} />
        <div className="flex flex-row bg-lightgray">
          <Route path={`${path}`}>
            <div className="w-full mx-0 mb-20 pt-14">
              <>
                {!loading && <div className="px-7">
                  <div className="flex items-center justify-between mt-2 text-2xl text-blue">
                    <span>Voucher</span>
                    <div className="space-x-3 w-100">
                      <ReactToPrint
                        trigger={() => <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                        >
                          Visualizar PDF
                        </Button>
                        }
                        content={() => componentRef.current}
                        onBeforeGetContent={() => {
                          const el = document.getElementById('desktop');
                          if (el) el.style.display = 'block';
                          return Promise.resolve();
                        }}
                        onAfterPrint={() => {
                          const el = document.getElementById('desktop');
                          if (el) el.style.display = '';
                        }}
                        onPrintError={() => {
                          const el = document.getElementById('desktop');
                          if (el) el.style.display = '';
                        }}

                      />

                    </div>
                  </div>
                  <div className="my-4 d-flex">
                    {success && <Alert className="mt-5" severity="success" color="success">
                      Voucher enviado com sucesso
                    </Alert>}
                  </div>
                  {voucher && voucher.customerData && (
                    <Content
                      {...props}
                      voucher={voucher}
                      ref={componentRef}
                    />
                  )}
                </div>}
              </>
            </div>
          </Route>
        </div>
      </div>
    </React.Fragment>
  </Switch>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(VoucherLink);